<template>
    <div>
        <PageTitle :title="$t('header.partidos_temporada', {temporada: lista_abonados.nombre})"></PageTitle>
        <FirstBanner></FirstBanner>
        <ListadoEventosClubs 
            v-if="eventos.length > 0" 
            :eventos="eventos"
        />
        <template v-else>
            <NoEvents/>
        </template>
    </div>
</template>

<script>
import PageTitle from '@/components/frontend/shared/PageTitle';
import FirstBanner from '@/components/frontend/shared/FirstBanner';
import ListadoEventosClubs from '@/components/frontend/events/listado/ListadoEventosClubs';
import NoEvents from '@/components/frontend/events/listado/NoEvents';

export default {
    computed: {
        lista_abonados() {
            return this.$store.getters.getListaAbonados;
        },
        eventos() {
            var array = [];

            var ahora = moment();

            if(this.events && this.events.data) {
                for (var i = 0; i < this.events.data.length; i++) {
                    var fecha = moment(this.events.data[i].fecha_sesion).add(2, 'hours');
                    if(ahora < fecha) {
                        array.push(this.events.data[i]);
                    }
                }
            }                

            return array;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        events() {
            return this.$store.getters.getFrontEvents;
        }
    },
    components: {
        PageTitle, ListadoEventosClubs, FirstBanner, NoEvents
    }
}
</script>
